module.exports = __webpack_public_path__ + "img/rocket.c38dfbef.svg";